import { CrystalMark, StarIcon } from '@/assets/icons';
import { formatNumber } from '@/utils/format';
import styles from './TopBar.module.scss';

export interface TopBarProps {
  balance: number;
}

export function TopBar({ balance }: TopBarProps) {
  return (
    <header className={styles.topbar}>
      <div className={styles.brand}>
        <CrystalMark size={26} />
        <span className={styles.brandName}>Shard</span>
      </div>
      <button type="button" className={styles.balanceChip} aria-label={`Balance: ${formatNumber(balance)} stars`}>
        <StarIcon size={16} />
        <span className={styles.balanceValue}>{formatNumber(balance)}</span>
      </button>
    </header>
  );
}
